import { render, staticRenderFns } from "./ContentReadMoreModal.vue?vue&type=template&id=028bd796&scoped=true"
import script from "./ContentReadMoreModal.vue?vue&type=script&lang=js"
export * from "./ContentReadMoreModal.vue?vue&type=script&lang=js"
import style0 from "./ContentReadMoreModal.vue?vue&type=style&index=0&id=028bd796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bd796",
  null
  
)

export default component.exports